import React, { Component } from "react";
import "./TotalCss.css";
import { Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { SiteTitle } from "./SiteTitle";
import { FetchDataUserlocalNetSetTable } from "./FetchDataUserlocalNetSetTable";
import { api_url } from "./globalFunction/global_string";

export class UserlocalNetSet extends Component {
  static displayName = UserlocalNetSet.name;

  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      isDataUnitNameFetched: false,
      isDataUnitUrlFetched: false,
      isDataFetched: true,
      fetchedData: {
        current_user_type: localStorage.getItem('login_user_type'),
        local_net_id: localStorage.getItem('login_user_net_id'),
        apiUrl: api_url + '/api/JRCC/LocalNetIdUnitIdReference',
      },
    }
  }

  render() {
    return (
      <div>
        <SiteTitle />
        <div className="mt-5">
          <h1 id="tableLabel" className='mb-3'>使用者區網單位設定</h1>
          <div id="site_manage" className="row col-12 mb-5">
          </div>
          {this.state.isDataFetched && <FetchDataUserlocalNetSetTable
            fetchedData={this.state.fetchedData}
          />}
        </div>
      </div>
    )
  }
}